import React from "react";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Person, LogoutRounded } from "@mui/icons-material";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import QuizIcon from "@mui/icons-material/Quiz";
import LockIcon from "@mui/icons-material/Lock";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { connect } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, Menu, MenuItem, useMediaQuery } from "@mui/material";
import TransferDialog from "./Transfer/TransferDialog";
import { MainContainer } from "./MainContainer";
import { setToken } from "../redux/action/authAction";
import { useDispatch} from "react-redux";
import ReceiptIcon  from '@mui/icons-material/Receipt';
import MailIcon from '@mui/icons-material/Mail';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const menu = [
  {
    name: "Portfolio",
    icon: BusinessCenterIcon,
    redirect: "/home",
  },
  {
    name: "Transactions",
    icon: Person,
    redirect: "/transactions",
  },
  {
    name: "Invoices",
    icon: ReceiptIcon,
    redirect: "/invoices",
  }
];

const settings = [
  {
    name: "View Profile",
    icon: Person,
    redirect: "/user-profile",
  },
  // {
  //   name: 'Coinbase Authorization',
  //   icon: MonetizationOnOutlinedIcon,
  //   redirect: '/coinbase-authorization'
  // },
  // {
  //   name: 'Preference',
  //   icon: TuneIcon,
  //   redirect: '/preference'
  // },
  {
    name: "Transfer (Deposit, Withdraw)",
    icon: TransferWithinAStationIcon,
    redirect: "/transfer",
  },
  {
    name: "Two-factor Authentication",
    icon: LockIcon,
    redirect: "/mfa",
  },
  {
    name: "Crypto Addresses",
    icon: AccountBalanceWalletIcon,
    redirect: "/crypto-address",
  },
  {
    name: "Additional Documents",
    icon: UploadFileIcon,
    redirect: "/choose-document-type",
  },
  {
    name: 'Invite',
    icon: MailIcon,
    redirect: '/invite'
  },
  {
    name: "Get Help",
    icon: QuizIcon,
    redirect: "/help",
  },
  {
    name: "FAQ",
    icon: LiveHelpIcon,
    redirect: "/faq",
  },
  {
    name: "Logout",
    icon: LogoutRounded,
    redirect: "/logout",
  },
];

const usePrevious = (value) => {
  const ref = React.useRef(null);
  React.useEffect(() => void (ref.current = value), [value]);
  return ref.current;
};

const SideDrawer = (props) => {
  const { userPortfolioSummary, userdata } = props;
  const KycStatus = userdata?.kyc_status;
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [nextPage, setNextPage] = React.useState(null);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);

  const { logout, user } = useAuth0();

  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
    

  React.useEffect(() => {
    const getUserMetadata = async () => {
        try {
        const accessToken = await getAccessTokenSilently({
            audience: `coinspaze-api`,
        });
        dispatch(setToken(accessToken));
        } catch (e) {
            console.log("error", e);
        }
    };
    getUserMetadata();
  }, [])

  React.useEffect(() => {
    if (nextPage !== null) {
      let temp = nextPage;
      setNextPage(null);
      navigate(temp);
    }
  }, [nextPage, navigate]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = (value) => {
    setOpenDialog(false);
  };

  const handleCloseUserMenu = (action) => {
    setAnchorElUser(null);
    if (action === "/logout") {
      logout();
    } else if (action === "/choose-document-type") {
      if (userdata && userdata.id_proof_uploaded && !userdata.address_proof_uploaded) {
        setNextPage("/upload-address-document");
      } else {
        setNextPage("/upload-document");
      }
    } else if (action !== "none") {
      setNextPage(action);
    }
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const isBigScreen = useMediaQuery("(min-width: 1140px)", false);
  const prevBigScreen = usePrevious(isBigScreen);
  React.useEffect(() => {
    if (isBigScreen !== prevBigScreen && isBigScreen !== open) {
      setOpen((prev) => !prev);
    }
  }, [isBigScreen, prevBigScreen, open]);
  const formatMoney = (num) => {
    return `$${(Math.round(num * 100) / 100).toFixed(2)}`;
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" open={open} style={{ background: "#2D0734" }}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/home"
              sx={{
                mr: 2,
                flexGrow: 1,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <img width={170} height={40} src={process.env.PUBLIC_URL + "/images/logo.png"} alt="logo" />
            </Typography>
            <div className="mr-2">{user?.email}</div>
            {user && (
              <Avatar
                alt="user.name"
                src={user.picture}
                onClick={handleOpenUserMenu}
                className="hover:cursor-pointer hover:outline hover:outline-offset-2 hover:outline-2 outline-[#CDA436]"
              >
                {user.name[0]}
              </Avatar>
            )}
            <Menu
              sx={{ mt: "45px", color: "#000" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={() => handleCloseUserMenu("none")}
            >
              {userPortfolioSummary && (
                <MenuItem key={"Balance"}>
                  <img
                    style={{
                      width: "57px",
                      height: "53px",
                      float: "left",
                      alt: "logo",
                    }}
                    src="/images/balance.png"
                    alt="Balance"
                  ></img>
                  <Typography style={{ color: "black", whiteSpace: "pre-line" }}>
                    {"   Balance<br/>   USD ".split("<br/>").join("\n")}
                    {formatMoney(userPortfolioSummary?.balance?.amount)}
                  </Typography>
                </MenuItem>
              )}
              {settings.map((setting) => (
                <MenuItem
                  key={setting.name}
                  onClick={() => handleCloseUserMenu(setting.redirect)}
                  disabled={setting.name === "Transfer (Deposit, Withdraw)" && KycStatus !== "verified"}
                >
                  <ListItemIcon>
                    <setting.icon fontSize="small" />
                  </ListItemIcon>
                  <Typography textAlign="center" style={{ color: "black" }}>
                    {setting.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {menu.map((menuItem, index) => (
              <ListItem key={menuItem.name} disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => handleCloseUserMenu(menuItem.redirect)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {index % 2 === 0 ? <BusinessCenterIcon /> : <Person />}
                  </ListItemIcon>
                  <ListItemText primary={menuItem.name} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
            ))}
            <ListItem key={"send&receive"} disablePadding sx={{ display: "block" }} onClick={handleClickOpen}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <CompareArrowsIcon />
                </ListItemIcon>
                <ListItemText primary={"Send & Receive"} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
            <TransferDialog open={openDialog} onClose={handleClose} sx={{ fullScreen: true }} />
          </List>
          <Divider />
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
              onClick={() => handleCloseUserMenu("/logout")}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <LogoutRounded />
              </ListItemIcon>
              <ListItemText primary={"Logout"} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          <MainContainer />
        </Box>
      </Box>
    </>
  );
};

const mapStatetoProps = (state) => {
  // console.log("state is here===>", state)
  return {
    userPortfolioSummary: state.home.userPortfolioSummary,
    userdata: state.auth.userdata,
  };
};
const mapDispatchtoProps = (dispatch) => {
  return {};
};
export default connect(mapStatetoProps, mapDispatchtoProps)(SideDrawer);
